import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancelPage() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-3xl mx-auto px-6 py-32 text-center">
      <div className="w-14 h-14 mx-auto rounded-full bg-lum-bg2 text-lum-text2 flex items-center justify-center mb-6">
        <XCircle />
      </div>
      <p className="overline mb-3">Checkout cancelled</p>
      <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05]">No charge. No worries.</h1>
      <p className="mt-6 text-lum-text2 max-w-lg mx-auto">
        Your bag is still saved. Come back when you&apos;re ready — your free gift is waiting.
      </p>
      <div className="mt-10 flex justify-center gap-4">
        <Link to="/cart" data-testid="cancel-back-to-cart" className="btn-primary inline-flex">Back to cart</Link>
        <Link to="/" className="btn-secondary inline-flex">Keep browsing</Link>
      </div>
    </div>
  );
}
